import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import 'react';
import { useTheme, jsx } from '@emotion/react';
import ButtonContainer from '../../shared-components/container/index.js';
import { ButtonContents, ButtonText } from '../../style.js';
import Style from './style.js';

var _excluded = ["as", "buttonColor", "buttonType", "children", "disabled", "onClick", "textColor"];
var LinkButton = _ref => {
  var {
    as = 'a',
    buttonColor,
    buttonType = 'primary',
    children,
    disabled = false,
    onClick = () => undefined,
    textColor
  } = _ref,
      rest = _objectWithoutProperties(_ref, _excluded);

  var theme = useTheme();
  var ContainerTag = as;
  var buttonColorWithTheme = buttonColor !== null && buttonColor !== void 0 ? buttonColor : theme.COLORS.primary;
  return jsx(ContainerTag, _extends({
    css: Style.linkButtonStyles({
      disabled,
      buttonType,
      buttonColor: buttonColorWithTheme,
      textColor,
      theme
    }),
    disabled: disabled,
    onClick: !disabled ? onClick : () => false // eslint-disable-next-line react/jsx-props-no-spreading

  }, rest), jsx(ButtonContents, {
    isLoading: false,
    isFullWidth: false,
    hasIcon: false
  }, jsx(ButtonText, {
    isLoading: false,
    hasIcon: false
  }, children)));
};
LinkButton.Container = ButtonContainer;

export { LinkButton };
